<mat-selection-list #shoes>
  @for (notification of notifications; track notification) {
    <mat-list-option>{{notification.label | translate}}</mat-list-option>
  }
</mat-selection-list>